import React from 'react';
import PropTypes from 'prop-types';
import { isUserAllowed } from '../../../shared/utils';
import { ROLES } from '../../../helper/constants'

const TemplatesHeader = ({ createTemplate }) => (
  <div className="d-flex justify-content-between">
    <div>
      <h2 className="mb-2"><strong>Manejador de Plantillas</strong></h2>
      <div className="top_linear_divaindo" />
    </div>
    {!isUserAllowed(ROLES.auditor) && <div>
      <button className="btn button_change black_resize_button" type="button" style={{ padding: '5px', width: '120px' }} onClick={() => createTemplate('create', null)}>
        Nueva Plantilla
      </button>
    </div>}
  </div>
);

TemplatesHeader.propTypes = {
  createTemplate: PropTypes.func.isRequired,
};

export default TemplatesHeader;
